import request from "@/utils/request";

// 用户登录
export function login(data) {
  return request({
    url: `/api/v1.user/login`,
    method: "post",
    data,
  });
}
// 用户注册
export function register(data) {
  return request({
    url: `/api/v1.user/reg`,
    method: "post",
    data,
  });
}
// 发送邮件验证码
export function sendEmail(data) {
  return request({
    url: `/api/v1.user/sendEmail`,
    method: "post",
    params: data,
  });
}
// 判断邮箱是否可用
export function isUseEmail(params) {
  return request({
    url: `/api/v1.user/isUseEmail`,
    method: "get",
    params,
  });
}
// 获取个人信息
export function getUserInfo(params) {
  return request({
    url: `/api/v1.user/userinfo`,
    method: "get",
    params,
  });
}
// 修改个人信息
export function editUserInfo(data) {
  return request({
    url: `/api/v1.user/edit`,
    method: "post",
    data,
  });
}
// 报名
export function registration(data) {
  return request({
    url: `/api/v1.user/registration`,
    method: "post",
    data,
  });
}
// // 报名详情
// export function registrationDetail(data) {
//   return request({
//     url: `/api/v1.user/registrationDetail`,
//     method: "post",
//     data
//   });
// }
// 提交作品
export function submitWorks(data) {
  return request({
    url: `/api/v1.user/submitWorks`,
    method: "post",
    data,
  });
}
// 我的报名
export function myRegistration(params) {
  return request({
    url: `/api/v1.user/myRegistration`,
    method: "get",
    params,
  });
}

// 作品列表查询
export function workListApi(params) {
  return request({
    url: `/api/v1.work/lists`,
    method: "GET",
    params,
  });
}

// 获取验证码
export function postCodeApi(data) {
  return request({
    url: `/api/v1.work/sendSms`,
    method: "POST",
    data,
  });
}

// 作品投票
export function postWorkVoteApi(data) {
  return request({
    url: `/api/v1.work/verify`,
    method: "POST",
    data,
  });
}

// 投票数查询
export function getVoteCountApi(params) {
  return request({
    url: `/api/v1.work/voteCount`,
    method: "GET",
    params,
  });
}

// 作品详情页查询
export function getWorkDeatilApi(params) {
  return request({
    url: `/api/v1.work/detail`,
    method: "GET",
    params,
  });
}
